export const initialState = {
    videoList: []
  };
